export default __webpack_public_path__ + "locales/it/Common.json?hash=a1304c85ddc7d9222fb6a80b97341b17";